export default __webpack_public_path__ + "static/media/monetizze.4ae1f56e.png";